export default __webpack_public_path__ + "locales/ja-JP/DeleteDialog.json?hash=dd06969f116df857cdada24f513394d0";